import { Box, Flex } from "@otrium/core";
import { Skeleton } from "src/atoms/Skeleton";
import { ShippingMethodsSkeleton } from "src/molecules/ShippingMethodsSkeleton";
import { CheckoutOrderSummarySkeleton } from "src/molecules/CheckoutOrderSummarySkeleton";

const CheckoutStepInfoSkeleton = (): JSX.Element => (
  <Flex
    flexDirection={["column", "column", "column", "row"]}
    width="100%"
    sx={{ gridColumn: "1 / -1" }}
  >
    <Box flex="1" mr={[3, 3, 3, 4]} ml={[3, 3, 3, 0]}>
      <Box height={550} width="100%">
        <Skeleton />
      </Box>
      <Box mt={3}>
        <ShippingMethodsSkeleton itemHeight={100} />
      </Box>
    </Box>
    <Box>
      <CheckoutOrderSummarySkeleton width={["100%", "100%", "100%", 390]} />
    </Box>
  </Flex>
);

export default CheckoutStepInfoSkeleton;
